// WCAG Filtering
// Element selectors
const topButtons = document.querySelectorAll(".dropdown-filter-toggle");
const submenuLinks = document.querySelectorAll(".yogatv-filter-wrapper .dropdown-menu");

// Helper functie voor focusbeheer
const focusableElementsSelector = "input, button, a, [tabindex]";
function getFocusableElements(container) {
    return Array.from(container.querySelectorAll(focusableElementsSelector))
        .filter((el) => !el.closest('[aria-hidden="true"]') && el.offsetParent !== null);
}

/*
const searchField = document.querySelector("#filter-houding-search");
if (searchField) {
    // workaround to prevent the opening of the first dropdown menu on pressing enter
    searchField.addEventListener("keydown", (event) => {
        if (event.key == "Enter") {
            event.preventDefault();
            var event = new Event('change');
            searchField.closest('form').dispatchEvent(event);
        }
    });
}
*/

// Event listeners voor top-level buttons
if (Array.isArray(topButtons) || topButtons instanceof NodeList) {
    topButtons.forEach((button, index, buttons) => {
        button.addEventListener("keydown", (event) => handleTopMenuKey(event, button, index, buttons));
        button.addEventListener("click", () => toggleSubNav(button));
    });
}

// Event listeners voor submenu links
if (Array.isArray(submenuLinks) || submenuLinks instanceof NodeList) {
    submenuLinks.forEach((link) => {
        link.addEventListener("keydown", (event) => handleSubmenuKey(event, link));
    });
}

// Event listeners voor checkboxes
document.querySelectorAll(".filter-dropdown-option-container").forEach((label) => {
    label.addEventListener("keydown", (event) => handleCheckboxKeydown(event, label));
});

// Key events voor top-level menu
function handleTopMenuKey(event, button, index, buttons) {
    const { key } = event;

    switch (key) {
        case "ArrowRight":
            event.preventDefault();
            focusNext(buttons, index);
            break;
        case "ArrowLeft":
            event.preventDefault();
            focusPrevious(buttons, index);
            break;
        case "Enter":
            event.preventDefault();
            toggleSubNav(button);
            break;
    }
}

// Key events voor submenu links
function handleSubmenuKey(event, link) {
    if (event.key === "Escape") {
        event.preventDefault();
        closeSubMenu(link.closest(".dropdown-menu"));
    }
}

// Key events voor checkboxes
function handleCheckboxKeydown(event, label) {
    if (event.key === " " || event.key === "Spacebar") {
        event.preventDefault();
        const checkbox = label.querySelector('input[type="checkbox"]');
        if (checkbox) {
            checkbox.checked = !checkbox.checked;
            checkbox.setAttribute("aria-checked", checkbox.checked.toString());
        }
    }
}

// Navigatie helpers
function focusNext(elements, currentIndex) {
    elements[(currentIndex + 1) % elements.length].focus();
}

function focusPrevious(elements, currentIndex) {
    elements[(currentIndex - 1 + elements.length) % elements.length].focus();
}

// Submenu functies
function toggleSubNav(button) {
    const submenuId = button.getAttribute("aria-controls");
    const submenu = document.getElementById(submenuId);
    const isExpanded = button.getAttribute("aria-expanded") === "true";

    closeAllSubmenus();

    if (!isExpanded && submenu) {
        button.setAttribute("aria-expanded", "true");
        submenu.setAttribute("aria-hidden", "false");
        submenu.classList.add("dropdown-active");
        focusFirstSubmenuItem(submenu);
    }
}

function closeSubMenu(submenu) {
    if (submenu) {
        submenu.classList.remove("dropdown-active");
        submenu.setAttribute("aria-hidden", "true");
        const controllingButton = document.querySelector(`button[aria-controls="${submenu.id}"]`);
        if (controllingButton) {
            controllingButton.setAttribute("aria-expanded", "false");
            controllingButton.focus();
        }
    }
}

function closeAllSubmenus() {
    document.querySelectorAll(".yogatv-filter-wrapper .dropdown-menu").forEach((menu) => {
        menu.classList.remove("dropdown-active");
        menu.setAttribute("aria-hidden", "true");
    });
    document.querySelectorAll(".dropdown-filter-toggle").forEach((button) => {
        button.setAttribute("aria-expanded", "false");
    });
}

function focusFirstSubmenuItem(submenu) {
    const focusableElements = getFocusableElements(submenu);
    if (focusableElements.length > 0) {
        focusableElements[0].focus();
    }
}

// Event voor buiten klikken
document.addEventListener("click", (event) => {
    if (!event.target.closest(".dropdown-filter-toggle") &&
        !event.target.closest(".dropdown-menu")) {
        closeAllSubmenus();
    }
});

// Event voor Escape-toets
document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
        closeAllSubmenus();
    }
});